import { addLocalProperty } from './localProperties';

const SUBMISSIONS_KEY = 'qubeyards-demo-submissions';
const REVIEWED_KEY = 'qubeyards-demo-reviewed';

const readJson = (key, fallback) => {
  try { return JSON.parse(window.localStorage.getItem(key) || JSON.stringify(fallback)); }
  catch { return fallback; }
};

export const readDemoSubmissions = () => readJson(SUBMISSIONS_KEY, []);
export const readReviewedSubmissions = () => readJson(REVIEWED_KEY, []);

export const saveDemoSubmission = (submission) => {
  const entries = readDemoSubmissions();
  const next = [{ ...submission, id: `demo-submission-${Date.now()}`, submittedAt: new Date().toISOString(), status: 'Pending review' }, ...entries];
  window.localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(next));
  return next;
};

export const reviewDemoSubmission = (id, status) => {
  const pending = readDemoSubmissions();
  const target = pending.find((entry) => entry.id === id);
  if (!target) return;
  if (status.toLowerCase().startsWith('approved')) {
    addLocalProperty(target, { source: 'developer', status: 'Admin reviewed · local' });
  }
  window.localStorage.setItem(SUBMISSIONS_KEY, JSON.stringify(pending.filter((entry) => entry.id !== id)));
  const reviewed = readReviewedSubmissions();
  window.localStorage.setItem(REVIEWED_KEY, JSON.stringify([{ ...target, status, reviewedAt: new Date().toISOString() }, ...reviewed]));
};

